<template>
  <el-container id="cobroAvaluos" style="justify-content: center; align-items: center;">
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="18"
      :md="16"
      :lg="14"
      :xl="12"
    >
      <el-row type="flex" justify="end">
        <el-col
          :xs="24"
          :sm="5"
        >
          <el-button
            type="primary"
            @click="$goBack()"
            style="width:100%;margin-bottom:10px;background-color:#884E93"
          >
            Volver
          </el-button>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="center"
        align="top"
      >
        <el-col>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="form"
            @submit.prevent.native
            @keydown.enter.native="search"
            :disabled="loading"
          >
            <el-form-item prop="accountNumberCURT">
              <label for="accountNumberCURT" class="el-form-item__label">
                <strong class="main">
                  Ingresa tu número de cuenta de predial
                  <br>
                  o tu Clave Única del Registro del Territorio (CURT)
                </strong>
                <span class="clue">
                  Ejemplo: 1114000000 o clave de 31 dígitos
                </span>
              </label>
              <el-input
                v-model="form.accountNumberCURT"
                maxlength="32"
              />
            </el-form-item>
            <el-form-item style="margin-bottom: 15px">
              <el-button
                id="add-btn"
                type="primary"
                style="width:150px;border: none;
                  background-color:#884E93;text-decoration:none !important"
                @click="search"
                :disabled="loading"
                :loading="loading"
              >
                Agregar
              </el-button>
            </el-form-item>
            <div v-if="predios.length !== 0">
              <br>
              <br>
              <h3
                style="color: #000000;
                  font-size: 16pt;
                  line-height: 26px;
                  font-weight: bold;
                  font-family: 'HelveticaNeue' !important;
                  font-weight: bold !important;"
              >
                Predios agregados
              </h3>
              <br>
              <div class="list-container">
                <ul>
                  <li v-for="predio in predios" :key="predio.oid">
                    <el-row
                      type="flex"
                      align="middle"
                      justify="center"
                    >
                      <i class="el-icon-office-building" />
                      <div class="col-on-xs">
                        <span style="margin-right: 3px">Identificador:</span>
                        <span>
                          {{ `${predio.Cuenta.length === 10 ?
                            `${predio.pk} - ${predio.Cuenta}`
                            : predio.Cuenta
                          }` }}
                        </span>
                        <span>
                          {{ `${predio.pk} - ${predio.Cuenta}` }}
                        </span>
                      </div>
                      <el-button
                        type="primary"
                        class="delete-btn"
                        @click="deleteOnList(predio)"
                      >
                        <i class="el-icon-delete" />
                      </el-button>
                    </el-row>
                  </li>
                </ul>
              </div>
              <br>
              <br>
              <br>
              <el-row
                type="flex"
                justify="end"
              >
                <el-button
                  id="submit-btn"
                  type="primary"
                  style="width:150px;border: none;
                  background-color:#884E93;text-decoration:none !important"
                  @click="submit"
                  :disabled="loading || predios.length === 0"
                  :loading="loading"
                >
                  Continuar
                </el-button>
              </el-row>
            </div>
          </el-form>
        </el-col>
      </el-row>
    </el-col>
    <el-footer class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col
          :xs="22"
          :sm="21"
          :md="20"
          :lg="19"
          :xl="18"
        >
          <div class="banner">
            <img src="../assets/images/footer-image.png" alt="banner footer">
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    /**
    * Valida que el campo cumpla con una de las longitudes
    * admitidas.
    */
    const validator = (val, rule, cb) => {
      let { accountNumberCURT } = this.form;
      accountNumberCURT = accountNumberCURT.trim();
      const acceptedLenghts = [
        10,
        30,
        31,
        32,
      ];
      if (!acceptedLenghts.includes(accountNumberCURT.length)) {
        return cb(new Error('Ingrese una Cuenta Predial o CURT válidos'));
      }
      return cb();
    };
    return {
      loading: false,
      form: {
        accountNumberCURT: null,
      },
      rules: {
        accountNumberCURT: [
          {
            required: true,
            message: 'El campo es requerido',
          },
          {
            pattern: /^([0-9])+$/g,
            message: 'El campo debe ser un valor numérico',
          },
          {
            validator,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      predios: (state) => state.avaluos.predios,
    }),
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        if (this.predios.length) {
          const Prediosid = this.predios.map((p) => p.pk);
          const response = await this.axios.post('ConceptoAvaluo', {
            Prediosid,
          });
          if (response?.status === 200) {
            const { data } = response;
            if (!data.alerta) {
              this.$store.dispatch('avaluos/SET_DATA', data);
              this.$router.push({ path: '/pagar-avaluos', query: this.$route.query });
            } else {
              this.$ErrorNotify({ response });
            }
          }
        }
      } catch (error) {
        this.$ErrorNotify(error);
      } finally {
        this.loading = false;
      }
    },
    /**
    * Remueve un elemento de la lista.
    */
    deleteOnList(predio) {
      let list = this.predios;
      list = list.filter((p) => p.pk !== predio.pk);
      this.$store.dispatch('avaluos/SET_DATA', { predios: [...list] });
    },
    /**
     * Válida el formulario antes de realizar la búsqueda.
     */
    beforeSearch() {
      return new Promise((resolve) => {
        this.$refs.form.validate(resolve);
      });
    },
    /**
     * Revisa que el predio no se encuentre agregado y
     * de ser así lo agrega, de lo contrario muestra un
     * mensaje al usuario.
     */
    addPredio(data) {
      // eslint-disable-next-line camelcase
      const { Cuenta, pk } = data;
      const predio = { Cuenta, pk };
      if (!this.predios.find((p) => p.pk === pk)) {
        this.$store.dispatch('avaluos/SET_DATA', { predios: [...this.predios, predio] });
        this.$refs.form.resetFields();
      } else {
        this.$ErrorNotify({
          response: {
            data: {
              alerta: 'El predio ya se encuentra agregado.',
            },
          },
        });
      }
    },
    /**
     * Controla el envío del formulario.
     * Revisa que las reglas aplicadas pasen y de
     * ser cierto ejecuta la búsqueda. De lo contrario,
     * muestra al usuario los errores o reglas no pasadas.
     */
    async search() {
      try {
        this.loading = true;
        const valid = await this.beforeSearch();
        if (valid) {
          const { accountNumberCURT } = this.form;
          const response = await this.axios.post('/ValidarCuentas', {
            Cuentas: [accountNumberCURT],
          });
          const { data } = response;
          if (!data?.alerta) {
            if (data?.PrediosEncontrados?.length) {
              this.addPredio(data.PrediosEncontrados[0]);
            } else {
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: 'Predio no encontrado.',
                  },
                },
              });
            }
          } else {
            this.$ErrorNotify({ response });
          }
        }
        this.loading = false;
      } catch (error) {
        this.$ErrorNotify(error);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.$store.dispatch('avaluos/CLEAR_INFO');
  },
};
</script>

<style lang="scss" scoped>
  .main-wrapper {
    padding: 40px 0;
    min-height: 60vh;
    .form {
      .form-title {
        color: #330066;
        font-size: 16pt;
        font-weight: bold;
        font-family: Tahoma;
      }
      .el-form-item__label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        text-align: left;
        .main {
          color: #000000;
          font-size: 14pt;
          line-height: 26px;
          font-weight: bold;
          font-family: 'HelveticaNeue' !important;
          font-weight: bold !important;
        }
        .clue {
          line-height: 26px;
          padding: 0px !important;
          margin: 0px !important;
          color: #808080;
          font-size: 14pt;
          font-family: 'HelveticaNeue' !important;
          font-weight: bold !important;
        }
      }
      .list-container {
        ul {
          list-style-type: none;
          li {
            padding: 15px;
            position: relative;
            // box-shadow: 1px 1px 1px 0px #808080;
            border-radius: 5px;
            margin-bottom: 15px;
            border: 1px solid #cecece !important;
            font-size: 16px;
            line-height: 30px;
            font-weight: 600;
            i.el-icon-office-building {
              font-size: 20px;
              margin-right: 5px;
              color: #FFFFFF;
              background-color: #B9A5CB;
              border-radius: 50%;
              padding: 5px;
            }
            *:not(i) {
              font-family: 'HelveticaNeue' !important;
            }
            .delete-btn {
              margin: 0;
              margin-left: auto;
              padding: 0;
              padding-right: 15px;
              background: transparent;
              border: none;
              color: #F56C6C;
              &:hover {
                color: #ec0101;
              }
            }
          }
        }
      }

      .el-input {
        margin-top: 5px;
      }
      #btn-submit {
        font-family: Arial;
        font-size: 12pt;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .hideOnXs {
      max-width: calc(100% - 150px);
    }
    .el-icon-office-building {
      width: 20px;
      height: 20px;
    }
    .el-icon-delete {
      font-size: 16px;
    }
    .col-on-xs {
      span:nth-child(2) {
        max-width: calc(100vw - 150px);
        overflow: hidden;
        text-overflow: ellipsis;
        // overflow-wrap: break-word;
      }
      span:nth-child(2) {
        display: none;
      }
    }
  }
</style>

<style lang="scss">
@media print {
  .header, .hide-on-print {
    display: none;
  }
}

@media only screen and (max-width: 550px) {
  .hideOnXs {
    display: none;
  }
  .col-on-xs {
    display: flex;
    flex-direction: column;
    span:nth-child(2) {
      display: unset !important;
    }
    span:nth-child(3) {
      display: none !important;
    }
  }
}

.el-footer {
  height: auto !important;
  margin-top: auto;
  .banner {
    width: 100%;
    overflow: hidden;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
